import axios from "axios";
import API_BASE_URL from "../ScrapFlow/config/config.server";

class SupportService {
  getAuthConfig() {
    const token = sessionStorage.getItem("sessionToken");

    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  }

  // /api/admin/* routes require a separate admin JWT (see
  // backend/routes/adminCore.js), not the regular rider/marketplace
  // sessionToken used everywhere else in this service.
  getAdminAuthConfig() {
    const token = sessionStorage.getItem("adminAuthToken");

    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  }

  async submitHelpRequest(operatorID, description) {
    const response = await axios.post(
      `${API_BASE_URL}/api/help`,
      { operatorID, description },
      this.getAuthConfig()
    );

    return response.data;
  }

  async getHelpRequests(operatorID) {
    const response = await axios.get(
      `${API_BASE_URL}/api/help/${operatorID}`,
      this.getAuthConfig()
    );

    return response.data;
  }

  async submitProblemReport(category, description) {
    const response = await axios.post(
      `${API_BASE_URL}/api/problem-reports`,
      { category, description },
      this.getAuthConfig()
    );

    return response.data;
  }

  async getProblemReports(operatorID) {
    const response = await axios.get(
      `${API_BASE_URL}/api/problem-reports/${operatorID}`,
      this.getAuthConfig()
    );

    return response.data;
  }

  async getProblemReportsAdmin() {
    const response = await axios.get(
      `${API_BASE_URL}/api/admin/problem-reports`,
      this.getAdminAuthConfig()
    );

    return response.data;
  }

  async updateProblemReportStatus(reportId, status) {
    const response = await axios.put(
      `${API_BASE_URL}/api/admin/problem-reports/${reportId}`,
      { status },
      this.getAdminAuthConfig()
    );

    return response.data;
  }

  async getAccountStatus(operatorID) {
    const response = await axios.get(
      `${API_BASE_URL}/api/account-status/${operatorID}`,
      this.getAuthConfig()
    );

    return response.data;
  }
}

export default new SupportService();
